module.exports = __webpack_public_path__ + "media/images/categories/icon_cat1-64b0eb9d835de75e9cacacc6a7737cd8.svg";